import { createAppSlice } from 'app/createAppSlice'
import {
  confirmAdjustment,
  confirmTrx,
  getDataTrx,
} from './requestTransactionAction'

const initialState = {
  approvedAt: null,
  canceledAt: null,
  createdAt: null,
  isLoading: false,
  isApproved: false,
  linkApproved: '',
  detail: null,
  isOpenModal: false,
  msg: '',
}

export const requestTransactionSlice = createAppSlice({
  name: 'purchase/commodity',
  initialState,
  reducers: (create) => ({
    toggleModal: create.reducer((state, { payload }) => {
      state.isOpenModal = !state.isOpenModal
    }),
    setMsg: create.reducer((state, { payload }) => {
      state.msg = payload
    }),
  }),
  extraReducers: (builder) => {
    builder
      .addCase(confirmTrx.pending, (state) => {
        state.isLoading = true
      })
      .addCase(confirmTrx.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.isApproved = true
        state.linkApproved = payload.link
        state.msg =
          payload.status === 'CONFIRM'
            ? state?.detail?.orderDetail?.type === 'BUY'
              ? `Terima kasih atas konfirmasi Anda, Mohon menunggu proses pembayaran dari ${state.detail?.sellerDetail?.fullName} pada aplikasi PasarMIKRO Business`
              : ''
            : 'Terima kasih atas konfirmasi Anda, Transaksi Telah dibatalkan'
      })
      .addCase(confirmTrx.rejected, (state, { payload }) => {
        state.isLoading = false
        state.isApproved = false
        state.linkApproved = ''
      })
      .addCase(confirmAdjustment.pending, (state) => {
        state.isLoading = true
      })
      .addCase(confirmAdjustment.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.isApproved = true
        state.linkApproved = payload.link
        state.msg =
          payload.status === 'APPROVED'
            ? state?.detail?.orderDetail?.type === 'BUY'
              ? `Terima kasih atas konfirmasi Anda, Mohon menunggu konfirmasi barang diterima dari ${state.detail?.buyerDetail?.fullName} pada aplikasi PasarMIKRO Business`
              : ''
            : 'Terima kasih atas konfirmasi Anda, penyesuaian telah ditolak'
      })
      .addCase(confirmAdjustment.rejected, (state, { payload }) => {
        state.isLoading = false
        state.isApproved = false
        state.linkApproved = ''
      })
      .addCase(getDataTrx.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getDataTrx.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.detail = payload
      })
      .addCase(getDataTrx.rejected, (state, { payload }) => {
        state.isLoading = false
      })
  },
})

export const { toggleModal, setMsg } = requestTransactionSlice.actions

export default requestTransactionSlice.reducer
